module.exports = __webpack_public_path__ + "media/images/v2/logo-header-87c2656ae5860de2013e9733c497b888.png";